<template>
  <!-- 11-2 医疗机构人才信息查看公用界面 -->
  <div class="main-css">
    <!-- 主要信息部分 -->
    <div class="main-box">
      <!-- 左边 -->
      <div class="left-box">
        <!-- 左边button部分 -->
        <!-- 主要信息部分 -->
        <div class="main-left-box">
          <div class="button-line">
            <button class="left-button-1" @click="collect">{{$t('collection')}}</button>
          </div>
          <!-- 显示图片 -->
          <div class="case-img">
            <div class="one-box-left1">
              <img :src="imageUrl?imageUrl:'@/assets/avatar.png'" @error="e=>{
         e.target.src = require('@/assets/avatar.png') }" alt=""/>
            </div>
            <div class="one-box-left2">
              <div class="one-box-left-line1">
                <div class="one-box-left-line-smallleft">
                  <p></p>
                </div>
                <div class="anonym">
                  <p>{{this.tableData.anonym}}</p>
                </div>
              </div>
              <div class="one-box-left-line2">
                <div class="one-box-left-line-smallleft">
                  <p>{{$t('name')}}</p>
                </div>
                <div class="one-box-left-line-smallright">
                  <p>{{this.tableData.name}}</p>
                </div>
              </div>
              <div class="one-box-left-line3">
                <div class="one-box-left-line-smallleft">
                  <p>{{$t('sex')}}</p>
                </div>
                <div class="one-box-left-line-smallright">
                  <p>
                    {{language==="CN"?tableData.sex_dictText:tableData.jpsex_dictText}}
                  </p>
                </div>
              </div>
              <div class="one-box-left-line4">
                <div class="one-box-left-line-smallleft">
                  <p>{{$t('birth')}}</p>
                </div>
                <div class="one-box-left-line-smallright">
                  <p>{{this.tableData.birth&&this.tableData.birth.split(" ")[0]}}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- 标签部分 -->
          <div class="label-line-box">
            <div
              :class="label1 ?  'label-box-active' : 'label-box'"
            >
              {{ $t("goodAtJapanese") }}
              <span>×</span>
            </div>
            <div
              :class="label2 ? 'label-box-active' : 'label-box'"
            >
              {{ $t("qualified") }}
              <span>×</span>
            </div>
            <div
              :class="label3 ? 'label-box-active' : 'label-box'"
            >
              {{ $t("interviewAtAnytime") }}
              <span>×</span>
            </div>
            <div
              :class="label4 ? 'label-box-active' : 'label-box'"
            >
              {{ $t("determined") }}
              <span>×</span>
            </div>
          </div>
          <!-- 第一行 -->
          <div class="inline-box">
            <div class="inline-left">
              <div class="inline-left-title">{{$t("contactAddress")}}</div>
              <div class="inline-left-title-main">{{$t('currentAddress')}}
                <div class="inline-left-title-main-right" :title="this.tableData.address">
                  {{this.tableData.address}}
                </div>
              </div>
              <div class="inline-left-title-main">{{$t('email')}}
                <div class="inline-left-title-main-right" :title="this.tableData.email">
                  {{this.tableData.email}}
                </div>
              </div>
              <div class="inline-left-title-main">{{$t('telephoneNumber')}}
                <div class="inline-left-title-main-right">
                  {{this.tableData.telephone}}
                </div>
              </div>
            </div>
            <div class="inline-right">
              <div class="normal-top-box-name">{{$t('education')}}</div>
              <div class="inline-left-title-main">{{$t('period')}}
                <div class="inline-left-title-main-right-long">
                {{this.tableData.startYear&&this.tableData.startYear.split(" ")[0]}}～{{this.tableData.endYear&&this.tableData.endYear.split(" ")[0]}}
                </div>
              </div>
              <div class="inline-left-title-main">{{$t('school')}}
                <div class="inline-left-title-main-right" :title="this.tableData.school">
                {{this.tableData.school}}
                </div>
              </div>
              <div class="inline-left-title-main">{{$t('major')}}
                <div class="inline-left-title-main-right" :title="this.tableData.profession">
                {{this.tableData.profession}}</div>
              </div>
            </div>
          </div>
          <!-- 第二行 -->
          <div class="inline-box">
            <div class="inline-left">
              <div class="inline-left-title">{{$t('qualification')}}</div>
              <div class="inline-left-title-main">
                {{$t('qualification1')}}
                <div class="inline-left-title-main-right">
                  {{this.tableData.qualification1}}
                </div>
              </div>

              <div class="inline-left-title-main">{{$t('qualification2')}}
                <div class="inline-left-title-main-right">
                  {{this.tableData.qualification2}}
                </div>
              </div>

              <div class="inline-left-title-main">{{$t('qualification3')}}
                <div class="inline-left-title-main-right">
                  {{this.tableData.qualification3}}
                </div>
              </div>

            </div>
            <div class="inline-right">
              <div class="inline-left-title">{{$t('workHistory')}}</div>

              <div class="inline-left-title-main">{{$t('period')}}
                <div class="inline-left-title-main-right-long">
                  {{this.tableData.enrollment&&this.tableData.enrollment.split(" ")[0]}}～{{this.tableData.graduation&&this.tableData.graduation.split(" ")[0]}}
                </div>
              </div>

              <div class="inline-left-title-main" >{{ $t('school') }}
                <div class="inline-left-title-main-right" :title="this.tableData.workPlace">
                  {{this.tableData.workPlace}}
                </div>
              </div>

              <div class="inline-left-title-main">{{$t('belongs')}}
                <div class="inline-left-title-main-right">
                 {{this.tableData.type}}
                </div>
              </div>
            </div>
          </div>
          <!-- 第三行 -->
          <div class="inline-box">
            <div class="inline-left">
              <div class="inline-left-title">{{$t('languageSkills')}}</div>
              <div class="inline-left-title-main">
                {{$t('japanese')}}
                <div class="inline-left-title-main-right">
                  {{language==="CN"?tableData.japanese_dictText:tableData.jpjapanese_dictText}}
                </div>
              </div>

              <div class="inline-left-title-main">{{$t('english')}}
                <div class="inline-left-title-main-right">
                  {{language==="CN"?tableData.english_dictText:tableData.jpenglish_dictText}}
                </div>
              </div>

              <div class="inline-left-title-main">{{$t('other')}}
                <div class="inline-left-title-main-right">
                  {{this.tableData.other}}
                </div>
              </div>

            </div>
            <div class="inline-right">
              <div class="inline-left-title">{{$t('request')}}</div>

              <div class="inline-left-title-main">{{$t('joinCompany')}}
                <div class="inline-left-title-main-right">
                  {{this.tableData.hopeEntrytime}}
                </div>
              </div>

              <div class="inline-left-title-main">{{$t('workLocation')}}
                <div class="inline-left-title-main-right" >
                  {{this.tableData.hopeWorkplace}}
                </div>
              </div>

              <div class="inline-left-title-main">{{$t('occupation')}}
                <div class="inline-left-title-main-right">
                  {{language==="CN"?tableData.hopeWorktype_dictText:tableData.jphopeWorktype_dictText}}
                </div>
              </div>
            </div>
          </div>

          <!-- 第五行 -->
          <div class="inline-log-box">
            <p class="long-box-title">{{$t('selfPR')}}</p>
            <div class="long-box-main">
              {{this.tableData.pr}}
            </div>
          </div>
        </div>
      </div>
      <!-- 右边聊天部分 -->
      <div class="right-box">
        <Socket></Socket>
      </div>
    </div>
  </div>
</template>
<script>
import Socket from "../../components/socket.vue";
import axios from "axios";
import AES from "../../js/AES";
import {addEducationCollect, getUrlFromOSS,insertMedicalCollection} from "../../js/api";

export default {
  name: "medicalInstitutionTalentInformationViewPublic",
  components: {Socket},
  data() {
    return {
        resumeId:"",
        tableData:[],
        imageUrl:"",
        label1: 0,
        label2: 0,
        label3: 0,
        label4: 0,
        labelListHandle: [],
        language:"",
    };
  },
  created() {
    if (this.$route.params.row) {
      this.resumeId=this.$route.params.row.resumeId
    }else{
       this.resumeId=this.$route.params.resumeId//医疗机关登录首页跳转传参
    }

    //获取当前语言的值
    this.language=window.localStorage.getItem('language')
    this.select();
  },
  mounted() {
    window.addEventListener('setItemEvent', this.languageChange, true)
  },
  destroyed() {
    window.removeEventListener('setItemEvent', this.languageChange, true)
  },
  computed: {},
  methods:{
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------")
      console.log(e)
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue
      }
    },
    //添加收藏
    collect(){
      console.log(this.$route.params.resumeId);
      var dto={
        systemEventId: this.$route.params.resumeId ,
        systemTypeId: 3
      }
      insertMedicalCollection(dto).then((res) => {
        if(res.data.code === "A0000"){
          console.log(res);
          this.$message({
            message: '恭喜你，收藏成功',
            type: 'success'
          });
          this.$router.push("/medicalInstitutionCollectionTalentsViewList");
        }else if(res.data.code === "A0506"){
          this.$message.error(this.$t('已收藏请勿重复操作'));
        }
        else{
          console.log(res);
        }
      })
        .catch(function (error) {
          console.log(error)
        })
    },
    //图片回显
    getUrl(url){
      console.log("url"+url);
      var fakeInfo={
        message: url
      }
      getUrlFromOSS(fakeInfo).then((res) => {
        if (res.data.code === "200 OK") {
          console.log("图片回显接口1");
          console.log(res);
          const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
          console.log(aesFecInfo);
          this.imageUrl = aesFecInfo.message
        }else{
          console.log(res);
        }
      }).catch(() => {
      })
    },
    //获取信息
    select(){
      var that=this;
      axios.get('/api/modules-parent/educationalInstitutionTalentInfo/resumeDetailQuery',
        {
          params: {
            resumeId:this.resumeId
          },
          headers:{
            'content-type': 'application/x-www-form-urlencoded',
            "token":localStorage.getItem("token")
          }
        }).then((res) => {
        console.log(res);
        if( res.data.code === "A0000"){
          const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
          that.tableData=aesFecInfo.data[0];
          that.label1=parseInt(aesFecInfo.data[0].label1)
          that.label2=parseInt(aesFecInfo.data[0].label2)
          that.label3=parseInt(aesFecInfo.data[0].label3)
          that.label4=parseInt(aesFecInfo.data[0].label4)
          console.log("人才信息");
          console.log(that.tableData);
          that.getUrl(that.tableData.avatar);
        }else{
          this.$message.error('查询失败。');
        }
      }).catch( (res) =>{} )
    },
    handleFinalClick(){
      console.log("点击了喜欢");
    },
    //   标签高亮显示
    labelIsShow(num) {
      if (num === 1) {
        this.label1 = 0;
        this.labelListLength(1);
      } else if (num === 2) {
        this.label2 = 0;
        this.labelListLength(2);
      } else if (num === 3) {
        this.label3 = 0;
        this.labelListLength(3);
      } else if (num === 4) {
        this.label4 = 0;
        this.labelListLength(4);
      }
    },
    //判断labelListHandle长度 并且去重方法
    labelListLength(num) {
      if (this.labelListHandle.length < 4) {
        if (num === 1) {
          if (this.labelListHandle.indexOf("日本語上手") === -1) {
            this.labelListAdd(1);
          } else {
            return;
          }
        } else if (num === 2) {
          if (this.labelListHandle.indexOf("資格あり") === -1) {
            this.labelListAdd(2);
          } else {
            return;
          }
        } else if (num === 3) {
          if (this.labelListHandle.indexOf("随時面接") === -1) {
            this.labelListAdd(3);
          } else {
            return;
          }
        } else if (num === 4) {
          if (this.labelListHandle.indexOf("決心あり") === -1) {
            this.labelListAdd(4);
          } else {
            return;
          }
        } else {
          return;
        }
      }
    },
    //labelListHandle  push 方法
    labelListAdd(num) {
      if (num === 1) {
        this.labelListHandle.push("日本語上手");
      } else if (num === 2) {
        this.labelListHandle.push("資格あり");
      } else if (num === 3) {
        this.labelListHandle.push("随時面接");
      } else if (num === 4) {
        this.labelListHandle.push("決心あり");
      } else {
        return;
      }
      console.log(this.labelListHandle);
    },
    //标签删除方法
    labelDel(num) {
      if (num === 1) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "日本語上手") {
            this.labelListHandle.splice(i, 1);
            this.label1 = 1;
          }
        }
      } else if (num === 2) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "資格あり") {
            this.labelListHandle.splice(i, 1);
            this.label2 = 1;
          }
        }
      } else if (num === 3) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "随時面接") {
            this.labelListHandle.splice(i, 1);
            this.label3 = 1;
          }
        }
      } else if (num === 4) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "決心あり") {
            this.labelListHandle.splice(i, 1);
            this.label4 = 1;
          }
        }
      }
      console.log(this.labelListHandle)
    },
  },
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
}

.top-title {
 min-height: 40px;
    min-width: 550px;
    overflow-x: scroll;
    display: flex;
    flex-wrap: wrap;
    /*justify-content: center;*/
    align-content: center;
}

.top-name {
  padding: 0 50px;
  height: 24px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 4px;
  text-align: center;
  line-height: 22px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: -0.02em;
  color: #686868;
  margin-top: 10px;
  float: left;
}

.case-num {
  padding: 0 10px;
  height: 24px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 4px;
  text-align: center;
  line-height: 22px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: -0.02em;
  color: #686868;
  margin-top: 10px;
  float: right;
  margin-left: 5px;
}

.main-box {
  width: 100%;
  margin: 0 auto;
  flex: 1;
  padding-top: 10px;
  box-sizing: border-box;
  overflow: hidden;
}

.left-box {
  margin-left: 5%;
  width: 45%;
  height: 100%;
  float: left;
  overflow: hidden;
  padding-bottom: 20px;
}
@media screen and (width: 1366px) {
  .main-left-box,.right-box {
    margin-top:0 !important;
    height: 100% !important;
  }
}
.main-left-box {
  width: 650px;
  padding-right: 18px;
  height: calc(100% - 80px);
  overflow-y: scroll;
  margin-top: 90px;
}
.left-button {
  width: 100%;
  height: 41px;
}

.left-button-1 {
  width: 85px;
  height: 40px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #51abff;
  float: left;
  margin-left: 21px;
  cursor: pointer;

}

.left-button-2 {
  width: 152px;
  height: 40px;
  background: #fc630c;
  border-radius: 4px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  float: right;
  margin-left: 5px;
}

.case-name {
  height: 55px;
  width: 100%;
}

.case-name .title {
  width: 440px;
  height: 25px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: #686868;
  border-bottom: 1px solid #686868;
}

.case-name .title-name {
  height: 30px;
  width: 440px;
  font-weight: 500;
  font-size: 18px;
  line-height: 30px;
  color: #686868;
}

.case-img {
  margin-top: 5px;
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: space-between;
}

.case-img img {
  margin-left: -1px;
  width: 135px;
  height: 122px;
}

.label {
  width: 100%;
  height: 26px;
  margin-top: 20px;
}

.label-box {
  padding: 0 5px;
  background: #b2b2b2;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #ffffff;
  float: left;
  margin-right: 20px;
}

.label-box span {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  line-height: 14px;
  color: #b2b2b2;
  text-align: center;
  margin-left: 2px;
  cursor: pointer;
}

.left-button {
  width: 100%;
  height: 41px;
}

.inline-left {
  width: 200px;
  height: 130px;
  margin-right: 45px;
  float: left;
  /*background: #51abff;*/
}
.inline-left .inline-left-title-main-right {
  width: 70%;
}

.inline-right {
  width: 240px;
  height: 130px;
  margin-right: 45px;
  float: left;
}

.inline-left-title {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
  /*background:yellow;*/
}

.inline-left-title-main {
  height: 30px;
  line-height: 30px;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.25px;
  color: #686868;
  /*background: peru;*/
}

.inline-left-title-main-right {
  width: calc(100% - 60px);
  min-width: 140px;
  height: 30px;
  line-height: 30px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
  margin-left: 10px;
  float: right;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.inline-left-title-main-right-long {
  width: calc(100% - 60px);
  height: 30px;
  font-weight: 400;
  font-size: 12px;
  letter-spacing: 0.2px;
  color: #686868;
  float: right;
}
.inline-box {
  height: 140px;
  width: 100%;
  margin-top: 10px;
}

.inline-log-box {
  margin-top: 10px;
  width: 100%;
  height: 200px;
}
.long-box-title {
  line-height: 30px;
  width: 485px;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
}
.long-box-main {
  width: 485px;
  min-height: 80px;
  padding-bottom: 100px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #686868;
  /* display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  /*显示的行数*/
  /* overflow: hidden;  */
  border-top: 1px solid #686868;

}

.right-box {
  margin-left: 3%;
  width: 42%;
  height: calc(100% - 160px);
  float: left;
  margin-top: 90px;
}

.one-box-left {
  width: 100%;
  height: 150%;
  padding-left: 40px;
  box-sizing: border-box;
  display: flex;
  justify-content: left;

}

.one-box-left1 {
  width: 125px;
  height: 120px;
  box-sizing: border-box;
  display: flex;
  justify-content: left;
  border-radius: 50%;
  /*cursor: pointer;*/
  align-items: center;
  overflow: hidden;
}

.one-box-left2 {
  width: 400px;
  height: 100px;
  background: #FFFFFF;
  border-radius: 4px;
  margin: auto;


}

.one-box-left-line1 {
  width: 80%;
  height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line2 {
  width: 80%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line3 {
  width: 80%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line4 {
  width: 80%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line-smallleft {
  width: 20%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 24px;
  /* or 171% */
  display: flex;
  align-items: center;
  /* 灰色字体 */
  color: #686868;

}
.inline-normal-box {
  width: 95%;
  background: #fff;
  display: flex;
  margin:15px 190px;
}
.normal-box {
  width: 25%;
  box-sizing: border-box;
}
.normal-top-box-name {
  width: 200px;
  height: 25px;
  box-sizing: border-box;
  border-bottom: 1px solid #686868;
  font-weight: 700;
  font-size: 14px;
  line-height: 25px;
  color: #686868;
}
.normal-bottom-box-name {
  height: 30px;
  font-weight: 700;
  font-size: 12px;
  line-height: 35px;
  letter-spacing: 0.25px;
  color: #686868;
}
.one-box-left-line-smallright {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* or 143% */
  display: flex;
  align-items: center;
  /* 灰色字体 */
  color: #686868;
}
.anonym{
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  display: flex;
  align-items: center;
  /* 灰色字体 */
  color: #8a8888;
}
.label-line-box{
  width: 540px;
  height: 30px;
  margin-top: 20px;
}
.label-box-active {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #51abff;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-right: 20px;
}
.label-box-active span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 2px;
  display: inline-block;
  color: #b2b2b2;
}
.label-box span {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  line-height: 14px;
  color: #b2b2b2;
  text-align: center;
  margin-left: 2px;
  cursor: pointer;
}
.button-line{
  width: 50px;
  height: 40px;
}

</style>



// WEBPACK FOOTER //
// src/pages/medicalInstitutionTalentInformationViewPublic/index.vue